import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(filtersAccordionStyles, {
    accordion: {
        css: css`
            ${contentSpacingStyles()}
        `,
    },
});
